import {Injectable, signal} from '@angular/core';
import {AppointmentApiService} from "@app/areas/appointments/services/appointment-api.service";
import {take} from "rxjs/operators";
import moment from "moment-timezone";
import {AppointmentDetail} from "@app/areas/appointments/models/appointment.interface";
import {LocalizeService} from "@services/helpers/localize/localize.service";
import {AlertService} from "@services/helpers/alert/alert.service";

@Injectable({
  providedIn: 'root'
})
export class AppointmentRibbonService {
  appts$ = signal<AppointmentDetail[]>([])

  constructor(
    private api: AppointmentApiService,
    private l: LocalizeService,
    private alert: AlertService,
  ) {
  }

  refresh(): void {
    const start = moment().startOf('day').utc()
    const end = moment().endOf('day').utc()

    this.api.list(start.format(), end.format())
      .pipe(take(1))
      .subscribe({
        next: res => this.appts$.set(res),
        error: err => {
          console.log('err', err)
          this.alert.error(this.l.l('LoadAppointments.Failed', 'There was an error loading your appointments.'))
        }
      })
  }
}
